module.exports = __webpack_public_path__ + "static/img/Josh-Papalii.cd5100a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Papalii.jpg
// module id = YDTc
// module chunks = 0